export const EDITOR_CONVERSION_PORTAL_ID: string = 'editor-conversion-portal-container';
export const ALL_PAGES_FF: string = 'confluence.frontend.fabric.editor.all-pages';
